import React from 'react';
import PromptCard from './PromptCard';
import MacroResultCard from './MacroResultCard';

const FoodLogList = ({ foodLog, editMealId, editMealData, handleEdit, handleDelete, handleEditChange, handleEditSave, handleEditCancel, handleMacroEdit }) => (
  <div className="food-log-list-container" style={{ margin: '0 auto', maxWidth: 600, position: 'relative', padding: '0 0.5rem', marginTop: 8, marginBottom: 0 }}>
    {foodLog && Array.isArray(foodLog.food) && foodLog.food.length > 0 && foodLog.food.map((item, idx) => (
      <React.Fragment key={item._id || idx}>
        <PromptCard
          prompt={item.name}
          date={item.date}
          timezone={item.timezone}
          onEdit={(newPrompt) => handleEdit({ ...item, name: newPrompt })}
          onDelete={() => handleDelete(item._id)}
        />
        {editMealId === item._id ? (
          <div className="card my-2 p-2">
            <input name="name" value={editMealData.name} onChange={handleEditChange} className="form-control my-1" />
            <input name="calories" value={editMealData.calories} onChange={handleEditChange} className="form-control my-1" />
            <input name="protein" value={editMealData.protein} onChange={handleEditChange} className="form-control my-1" />
            <input name="carbs" value={editMealData.carbs} onChange={handleEditChange} className="form-control my-1" />
            <input name="fat" value={editMealData.fat} onChange={handleEditChange} className="form-control my-1" />
            <input name="serving_size" value={editMealData.serving_size || ''} onChange={handleEditChange} className="form-control my-1" />
            <input name="description" value={editMealData.description || ''} onChange={handleEditChange} className="form-control my-1" />            <button className="btn btn-success btn-sm me-2" onClick={handleEditSave}>Save</button>
            <button className="btn btn-secondary btn-sm" onClick={handleEditCancel}>Cancel</button>
          </div>
        ) : (
          <MacroResultCard
            calories={item.calories}
            carbs={item.carbs}
            protein={item.protein}
            fat={item.fat}
            description={item.description || 'No description available.'}
            time={item.date ? new Date(item.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
            serving_size={item.serving_size}
            _source={item.source}
            name={item.name}
            onEdit={(newMacros) => handleMacroEdit({ ...newMacros, _id: item._id })}
            onDelete={() => handleDelete(item._id)}
          />
        )}
      </React.Fragment>
    ))}
    {foodLog && Array.isArray(foodLog.exercise) && foodLog.exercise.length > 0 && foodLog.exercise.map((item, idx) => (
      <React.Fragment key={item._id || idx}>
        <PromptCard
          prompt={item.name}
          date={item.date}
          timezone={item.timezone}
          onEdit={(newPrompt) => handleEdit({ ...item, name: newPrompt })}
          onDelete={() => handleDelete(item._id)}
        />
        {editMealId === item._id ? (
          <div className="card my-2 p-2">
            <input name="name" value={editMealData.name} onChange={handleEditChange} className="form-control my-1" />
            <input name="calories" value={editMealData.calories} onChange={handleEditChange} className="form-control my-1" />
            <input name="protein" value={editMealData.protein} onChange={handleEditChange} className="form-control my-1" />
            <input name="carbs" value={editMealData.carbs} onChange={handleEditChange} className="form-control my-1" />
            <input name="fat" value={editMealData.fat} onChange={handleEditChange} className="form-control my-1" />
            <input name="serving_size" value={editMealData.serving_size || ''} onChange={handleEditChange} className="form-control my-1" />
            <input name="description" value={editMealData.description || ''} onChange={handleEditChange} className="form-control my-1" />
            <button className="btn btn-success btn-sm me-2" onClick={handleEditSave}>Save</button>
            <button className="btn btn-secondary btn-sm" onClick={handleEditCancel}>Cancel</button>          </div>        ) : (
          <MacroResultCard
            calories={item.calories}
            carbs={item.carbs}
            protein={item.protein}
            fat={item.fat}
            description={item.description || 'No description available.'}
            time={item.date ? new Date(item.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
            serving_size={item.serving_size}
            _source={item.source}
            name={item.name}
            onEdit={(newMacros) => handleMacroEdit({ ...newMacros, _id: item._id })}            onDelete={() => handleDelete(item._id)}
            isExercise={true}
          />
        )}
      </React.Fragment>
    ))}
    {(!foodLog || ((Array.isArray(foodLog.food) && foodLog.food.length === 0) && (Array.isArray(foodLog.exercise) && foodLog.exercise.length === 0))) && (
      <div className="food-log-empty text-muted text-center" style={{ padding: '1.5rem 0', fontSize: 17 }}>
        No entries for this day.
      </div>
    )}
  </div>
);

export default FoodLogList;
